// client/src/pages/legalContent.js
// Draft legal copy for Best Place.
// Important: replace all TODO fields before publishing.
// This is a practical SaaS legal draft, not a substitute for review by a qualified lawyer/tax adviser.

export const LEGAL_LANGS = ["de", "en", "uk", "fr", "nl", "pl", "it", "da", "es", "no"];

export const LEGAL_PROVIDER = {
  brandName: "Best Place",
  domain: "best-place.club",
  siteUrl: "https://best-place.club",

  legalName: {
    de: "Einzelunternehmer Ivan Ruzhytskyi",
    en: "Individual Entrepreneur Ivan Ruzhytskyi",
    uk: "ФОП Ружицький Іван Іванович",
    fr: "Entrepreneur individuel Ivan Ruzhytskyi",
    nl: "Eenmanszaak Ivan Ruzhytskyi",
    pl: "Jednoosobowy przedsiębiorca Ivan Ruzhytskyi",
    it: "Imprenditore individuale Ivan Ruzhytskyi",
    da: "Enkeltmandsvirksomhed Ivan Ruzhytskyi",
    es: "Empresario individual Ivan Ruzhytskyi",
    no: "Enkeltpersonforetak Ivan Ruzhytskyi",
  },

  businessAddress: {
    de: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ukraine",
    en: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ukraine",
    uk: "01103, Україна, м. Київ, вул. Андрія Верхогляда, 3/45",
    fr: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ukraine",
    nl: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Oekraïne",
    pl: "Andriia Verkhohliada Str. 3/45, 01103 Kijów, Ukraina",
    it: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ucraina",
    da: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ukraine",
    es: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ucrania",
    no: "Andriia Verkhohliada Str. 3/45, 01103 Kyiv, Ukraina",
  },

  country: {
    de: "Ukraine",
    en: "Ukraine",
    uk: "Україна",
    fr: "Ukraine",
    nl: "Oekraïne",
    pl: "Ukraina",
    it: "Ucraina",
    da: "Ukraine",
    es: "Ucrania",
    no: "Ukraina",
  },

  registrationNumber: {
    de: "nicht öffentlich angegeben",
    en: "not publicly disclosed",
    uk: "не вказується публічно",
    fr: "non publié",
    nl: "niet openbaar vermeld",
    pl: "nieujawniony publicznie",
    it: "non divulgato pubblicamente",
    da: "ikke offentligt oplyst",
    es: "no divulgado públicamente",
    no: "ikke offentlig oppgitt",
  },

  vatId: {
    de: "nicht anwendbar / nicht angegeben",
    en: "not applicable / not provided",
    uk: "не застосовується / не вказується",
    fr: "non applicable / non fourni",
    nl: "niet van toepassing / niet verstrekt",
    pl: "nie dotyczy / nie podano",
    it: "non applicabile / non fornito",
    da: "ikke relevant / ikke oplyst",
    es: "no aplicable / no proporcionado",
    no: "ikke aktuelt / ikke oppgitt",
  },

  email: "support@best-place.club",
  phone: "+38 (096) 77-50-115",

  supportHours: {
    de: "Montag–Freitag, 10:00–18:00 Uhr Kiewer Zeit",
    en: "Monday–Friday, 10:00–18:00 Kyiv time",
    uk: "Понеділок–п’ятниця, 10:00–18:00 за Києвом",
    fr: "lundi–vendredi, 10:00–18:00 heure de Kyiv",
    nl: "maandag–vrijdag, 10:00–18:00 Kyiv-tijd",
    pl: "poniedziałek–piątek, 10:00–18:00 czasu kijowskiego",
    it: "lunedì–venerdì, 10:00–18:00 ora di Kyiv",
    da: "mandag–fredag, 10:00–18:00 Kyiv-tid",
    es: "lunes–viernes, 10:00–18:00 hora de Kyiv",
    no: "mandag–fredag, 10:00–18:00 Kyiv-tid",
  },

  pricingCurrency: "EUR",
  paymentProvider: "WayForPay",
  trialDays: "14",

  // Final governing law / dispute resolution should be confirmed before paid launch.
  governingLaw: {
    de: "das Recht der Ukraine, soweit zwingende gesetzliche Vorschriften nichts anderes vorsehen",
    en: "the laws of Ukraine, unless mandatory legal rules provide otherwise",
    uk: "право України, якщо обов’язкові норми законодавства не передбачають іншого",
    fr: "le droit ukrainien, sauf disposition légale impérative contraire",
    nl: "het recht van Oekraïne, tenzij dwingende wettelijke regels anders bepalen",
    pl: "prawo Ukrainy, chyba że bezwzględnie obowiązujące przepisy stanowią inaczej",
    it: "il diritto ucraino, salvo diversa disposizione di norme imperative",
    da: "ukrainsk ret, medmindre ufravigelige lovregler bestemmer andet",
    es: "las leyes de Ucrania, salvo que normas legales obligatorias dispongan lo contrario",
    no: "ukrainsk rett, med mindre ufravikelige lovregler bestemmer noe annet",
  },

  lastUpdated: "14 June 2026",
};

export function normalizeLegalLang(value) {
  const v = String(value || "").trim().toLowerCase();
  return LEGAL_LANGS.includes(v) ? v : "de";
}

export function getLegalText(value, lang) {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value[lang] || value.en || value.de || "";
}

function providerValue(key, lang = "en") {
  const value = LEGAL_PROVIDER[key];

  if (value && typeof value === "object") {
    return value[lang] || value.en || value.de || "";
  }

  return value || "";
}

export function applyProviderVars(text, lang = "en") {
  return String(text || "")
    .replaceAll("{{brand}}", LEGAL_PROVIDER.brandName)
    .replaceAll("{{domain}}", LEGAL_PROVIDER.domain)
    .replaceAll("{{siteUrl}}", LEGAL_PROVIDER.siteUrl)
    .replaceAll("{{legalName}}", providerValue("legalName", lang))
    .replaceAll("{{businessAddress}}", providerValue("businessAddress", lang))
    .replaceAll("{{country}}", providerValue("country", lang))
    .replaceAll("{{registrationNumber}}", providerValue("registrationNumber", lang))
    .replaceAll("{{vatId}}", providerValue("vatId", lang))
    .replaceAll("{{email}}", LEGAL_PROVIDER.email)
    .replaceAll("{{phone}}", LEGAL_PROVIDER.phone)
    .replaceAll("{{supportHours}}", providerValue("supportHours", lang))
    .replaceAll("{{pricingCurrency}}", LEGAL_PROVIDER.pricingCurrency)
    .replaceAll("{{paymentProvider}}", LEGAL_PROVIDER.paymentProvider)
    .replaceAll("{{trialDays}}", LEGAL_PROVIDER.trialDays)
    .replaceAll("{{lastUpdated}}", LEGAL_PROVIDER.lastUpdated)
    .replaceAll("{{governingLaw}}", providerValue("governingLaw", lang));
}

export const LEGAL_UI = {
  back: {
    de: "Zurück",
    en: "Back",
    uk: "Назад",
    fr: "Retour",
    nl: "Terug",
    pl: "Wstecz",
    it: "Indietro",
    da: "Tilbage",
    es: "Atrás",
    no: "Tilbake",
  },
  nav: {
    pricing: {
      de: "Preise",
      en: "Pricing",
      uk: "Тарифи",
      fr: "Tarifs",
      nl: "Prijzen",
      pl: "Cennik",
      it: "Prezzi",
      da: "Priser",
      es: "Precios",
      no: "Priser",
    },
    terms: {
      de: "AGB",
      en: "Terms",
      uk: "Умови",
      fr: "Conditions",
      nl: "Voorwaarden",
      pl: "Regulamin",
      it: "Termini",
      da: "Vilkår",
      es: "Términos",
      no: "Vilkår",
    },
    privacy: {
      de: "Datenschutz",
      en: "Privacy",
      uk: "Конфіденційність",
      fr: "Confidentialité",
      nl: "Privacy",
      pl: "Prywatność",
      it: "Privacy",
      da: "Privatliv",
      es: "Privacidad",
      no: "Personvern",
    },
    refund: {
      de: "Kündigung & Erstattung",
      en: "Cancellation & Refunds",
      uk: "Скасування і повернення",
      fr: "Annulation et remboursements",
      nl: "Annulering en terugbetalingen",
      pl: "Anulowanie i zwroty",
      it: "Cancellazione e rimborso",
      da: "Annullering og refundering",
      es: "Cancelación y reembolso",
      no: "Avbestilling og refusjon",
    },
    impressum: {
      de: "Impressum",
      en: "Legal Notice",
      uk: "Правова інформація",
      fr: "Mentions légales",
      nl: "Juridische kennisgeving",
      pl: "Informacje prawne",
      it: "Note legali",
      da: "Juridisk meddelelse",
      es: "Aviso legal",
      no: "Juridisk informasjon",
    },
  },
};

export const LEGAL_PAGES = {
  pricing: {
    title: {
      de: "Preise",
      en: "Pricing",
      uk: "Тарифи",
      fr: "Tarifs",
      pl: "Cennik",
      nl: "Prijzen",
      no: "Priser",
    },
    intro: {
      de: "{{brand}} ist ein B2B-SaaS-Service für Restaurants, Cafés, Bars und ähnliche Gastgewerbebetriebe.",
      en: "{{brand}} is a B2B SaaS service for restaurants, cafés, bars and similar hospitality businesses.",
      uk: "{{brand}} — це B2B SaaS-сервіс для ресторанів, кафе, барів та інших закладів гостинності.",
      fr: "{{brand}} est un service SaaS B2B destiné aux restaurants, cafés, bars et établissements similaires.",
      pl: "{{brand}} to usługa SaaS B2B dla restauracji, kawiarni, barów i podobnych firm gastronomicznych.",
      nl: "{{brand}} is een B2B SaaS-dienst voor restaurants, cafés, bars en vergelijkbare horecabedrijven.",
      no: "{{brand}} er en B2B SaaS-tjeneste for restauranter, kafeer, barer og lignende serveringssteder.",
    },
    sections: [
      {
        h: {
          de: "Aktueller Status",
          en: "Current status",
          uk: "Поточний статус",
          fr: "Statut actuel",
          pl: "Aktualny status",
          nl: "Huidige status",
          no: "Nåværende status",
        },
        p: [
          {
            de: "{{brand}} kann derzeit als kostenlose Pilotversion oder Testversion für ausgewählte Betriebe angeboten werden. Wenn ein kostenpflichtiger Tarif aktiviert wird, gelten die auf dieser Seite angezeigten Preis- und Vertragsbedingungen.",
            en: "{{brand}} may currently be offered as a free pilot or trial version for selected businesses. If a paid plan is activated, the pricing and subscription terms shown on this page apply.",
            uk: "{{brand}} наразі може надаватися як безкоштовна пілотна або тестова версія для окремих закладів. Якщо буде активовано платний тариф, застосовуються ціни й умови підписки, показані на цій сторінці.",
            fr: "{{brand}} peut actuellement être proposé comme version pilote ou d’essai gratuite pour certains établissements. Si une formule payante est activée, les prix et conditions d’abonnement indiqués sur cette page s’appliquent.",
            pl: "{{brand}} może być obecnie oferowany jako bezpłatna wersja pilotażowa lub testowa dla wybranych firm. Po aktywacji płatnego planu obowiązują ceny i warunki subskrypcji wskazane na tej stronie.",
            nl: "{{brand}} kan momenteel worden aangeboden als gratis pilot- of proefversie voor geselecteerde bedrijven. Als een betaald abonnement wordt geactiveerd, gelden de prijzen en abonnementsvoorwaarden op deze pagina.",
            no: "{{brand}} kan for øyeblikket tilbys som en gratis pilot- eller prøveversjon for utvalgte virksomheter. Hvis en betalt plan aktiveres, gjelder prisene og abonnementsvilkårene som vises på denne siden.",
          },
        ],
      },
      {
        h: {
          de: "Währung, Steuern und Rechnungen",
          en: "Currency, taxes and invoices",
          uk: "Валюта, податки та рахунки",
          fr: "Devise, taxes et factures",
          pl: "Waluta, podatki i faktury",
          nl: "Valuta, belastingen en facturen",
          no: "Valuta, skatter og fakturaer",
        },
        p: [
          {
            de: "Die Hauptwährung für kostenpflichtige Tarife ist {{pricingCurrency}}. Vor der Aktivierung eines kostenpflichtigen Tarifs erhält der Restaurantkunde eine kostenlose Testphase von {{trialDays}} Tagen und kann den Dienst während dieser Testphase beenden, bevor regelmäßige Zahlungen beginnen.",
            en: "The main currency for paid plans is {{pricingCurrency}}. Before a paid plan is activated, the restaurant customer receives a free {{trialDays}}-day trial and may cancel during that trial before recurring payments begin.",
            uk: "Основна валюта платних тарифів — {{pricingCurrency}}. Перед активацією платного тарифу ресторан-клієнт отримує безкоштовний тестовий період {{trialDays}} днів і може відмовитися від сервісу протягом цього періоду до початку регулярних платежів.",
            fr: "La devise principale des formules payantes est {{pricingCurrency}}. Avant l’activation d’une formule payante, le restaurant client bénéficie d’un essai gratuit de {{trialDays}} jours et peut annuler pendant cet essai avant le début des paiements récurrents.",
            pl: "Główną walutą płatnych planów jest {{pricingCurrency}}. Przed aktywacją płatnego planu klient restauracyjny otrzymuje bezpłatny {{trialDays}}-dniowy okres próbny i może zrezygnować w tym okresie przed rozpoczęciem płatności cyklicznych.",
            nl: "De hoofdvaluta voor betaalde abonnementen is {{pricingCurrency}}. Voordat een betaald abonnement wordt geactiveerd, krijgt de restaurantklant een gratis proefperiode van {{trialDays}} dagen en kan hij tijdens die proefperiode annuleren voordat terugkerende betalingen beginnen.",
            no: "Hovedvalutaen for betalte planer er {{pricingCurrency}}. Før en betalt plan aktiveres, får restaurantkunden en gratis prøveperiode på {{trialDays}} dager og kan kansellere i prøveperioden før gjentakende betalinger starter.",
          },
          {
            de: "Zahlungen für kostenpflichtige SaaS-Abonnements können über {{paymentProvider}} oder einen anderen auf der Checkout-Seite genannten Zahlungsdienstleister verarbeitet werden. Steuern, Umsatzsteuer, Reverse-Charge oder lokale Abgaben müssen separat im Zahlungs- und Rechnungsprozess geprüft und angegeben werden.",
            en: "Payments for paid SaaS subscriptions may be processed through {{paymentProvider}} or another payment provider shown at checkout. Taxes, VAT, reverse-charge treatment or local charges must be checked and stated separately in the payment and invoice process.",
            uk: "Платежі за платні SaaS-підписки можуть оброблятися через {{paymentProvider}} або іншого платіжного провайдера, зазначеного на сторінці оплати. Податки, ПДВ, reverse charge або місцеві збори потрібно окремо перевірити й зазначити в процесі оплати та виставлення рахунку.",
            fr: "Les paiements des abonnements SaaS payants peuvent être traités via {{paymentProvider}} ou un autre prestataire indiqué lors du paiement. Les taxes, la TVA, l’autoliquidation ou les frais locaux doivent être vérifiés et indiqués séparément dans le processus de paiement et de facturation.",
            pl: "Płatności za płatne subskrypcje SaaS mogą być przetwarzane przez {{paymentProvider}} lub innego dostawcę płatności wskazanego przy płatności. Podatki, VAT, odwrotne obciążenie lub opłaty lokalne należy osobno sprawdzić i wskazać w procesie płatności i fakturowania.",
            nl: "Betalingen voor betaalde SaaS-abonnementen kunnen worden verwerkt via {{paymentProvider}} of een andere betalingsprovider die bij het afrekenen wordt getoond. Belastingen, btw, verleggingsregeling of lokale heffingen moeten afzonderlijk worden gecontroleerd en vermeld in het betalings- en factuurproces.",
            no: "Betalinger for betalte SaaS-abonnementer kan behandles via {{paymentProvider}} eller en annen betalingsleverandør som vises i checkout. Skatter, mva., reverse-charge eller lokale avgifter må kontrolleres og oppgis separat i betalings- og fakturaprosessen.",
          },
        ],
      },
      {
        h: {
          de: "Keine Zahlungen von Restaurantgästen",
          en: "No payments from restaurant guests",
          uk: "Без платежів від гостей ресторану",
          fr: "Aucun paiement des clients du restaurant",
          pl: "Brak płatności od gości restauracji",
          nl: "Geen betalingen van restaurantgasten",
          no: "Ingen betalinger fra restaurantgjester",
        },
        p: [
          {
            de: "{{brand}} verkauft Software. Derzeit verarbeitet {{brand}} keine Zahlungen von Restaurantgästen für Speisen oder Getränke und ist nicht der Verkäufer der Restaurantprodukte.",
            en: "{{brand}} sells software. At this stage, {{brand}} does not process restaurant guest payments for food or drinks and is not the seller of restaurant products.",
            uk: "{{brand}} продає програмне забезпечення. На цьому етапі {{brand}} не обробляє платежі гостей ресторану за їжу чи напої і не є продавцем товарів ресторану.",
            fr: "{{brand}} vend un logiciel. À ce stade, {{brand}} ne traite pas les paiements des clients des restaurants pour les plats ou boissons et n’est pas le vendeur des produits du restaurant.",
            pl: "{{brand}} sprzedaje oprogramowanie. Na tym etapie {{brand}} nie przetwarza płatności gości restauracji za jedzenie lub napoje i nie jest sprzedawcą produktów restauracji.",
            nl: "{{brand}} verkoopt software. Op dit moment verwerkt {{brand}} geen betalingen van restaurantgasten voor eten of drinken en is het niet de verkoper van restaurantproducten.",
            no: "{{brand}} selger programvare. På dette stadiet behandler {{brand}} ikke betalinger fra restaurantgjester for mat eller drikke og er ikke selger av restaurantens produkter.",
          },
        ],
      },
    ],
  },

  terms: {
    title: {
      de: "Allgemeine Geschäftsbedingungen",
      en: "Terms & Conditions",
      uk: "Умови користування",
      fr: "Conditions générales",
      pl: "Regulamin świadczenia usług",
      nl: "Algemene voorwaarden",
      no: "Vilkår og betingelser",
    },
    intro: {
      de: "Diese Bedingungen regeln die Nutzung von {{domain}} und des {{brand}}-Services. Der Service richtet sich an Geschäftskunden.",
      en: "These Terms govern the use of {{domain}} and the {{brand}} service. The Service is intended for business customers.",
      uk: "Ці Умови регулюють використання {{domain}} та сервісу {{brand}}. Сервіс призначений для бізнес-клієнтів.",
      fr: "Les présentes Conditions régissent l’utilisation de {{domain}} et du service {{brand}}. Le service est destiné aux clients professionnels.",
      pl: "Niniejszy Regulamin reguluje korzystanie z {{domain}} oraz usługi {{brand}}. Usługa jest przeznaczona dla klientów biznesowych.",
      nl: "Deze Voorwaarden regelen het gebruik van {{domain}} en de {{brand}}-dienst. De dienst is bedoeld voor zakelijke klanten.",
      no: "Disse vilkårene regulerer bruken av {{domain}} og {{brand}}-tjenesten. Tjenesten er beregnet på bedriftskunder.",
    },
    sections: [
      {
        h: {
          de: "1. Anbieter und Vertragsparteien",
          en: "1. Provider and contracting parties",
          uk: "1. Постачальник і сторони договору",
          fr: "1. Fournisseur et parties contractantes",
          pl: "1. Dostawca i strony umowy",
          nl: "1. Aanbieder en contractspartijen",
          no: "1. Leverandør og avtalepartene",
        },
        p: [
          {
            de: "Der Anbieter des Services ist in der rechtlichen Anbieterkennzeichnung angegeben. Wenn Sie den Service für ein Unternehmen nutzen, bestätigen Sie, dass Sie berechtigt sind, dieses Unternehmen zu vertreten.",
            en: "The provider of the Service is identified in the Legal Notice. If you use the Service for a business, you confirm that you are authorised to represent that business.",
            uk: "Постачальник сервісу зазначений у розділі правової інформації. Якщо ви використовуєте сервіс від імені бізнесу, ви підтверджуєте, що маєте право представляти цей бізнес.",
            fr: "Le fournisseur du service est indiqué dans les mentions légales. Si vous utilisez le service pour une entreprise, vous confirmez que vous êtes autorisé à représenter cette entreprise.",
            pl: "Dostawca usługi jest wskazany w informacjach prawnych. Jeśli korzystasz z usługi w imieniu firmy, potwierdzasz, że jesteś uprawniony do jej reprezentowania.",
            nl: "De aanbieder van de dienst staat vermeld in de juridische kennisgeving. Als u de dienst namens een bedrijf gebruikt, bevestigt u dat u bevoegd bent om dat bedrijf te vertegenwoordigen.",
            no: "Leverandøren av tjenesten er oppgitt i den juridiske informasjonen. Hvis du bruker tjenesten på vegne av en virksomhet, bekrefter du at du har rett til å representere virksomheten.",
          },
        ],
      },
      {
        h: {
          de: "2. Beschreibung des Services",
          en: "2. Description of the Service",
          uk: "2. Опис сервісу",
          fr: "2. Description du service",
          pl: "2. Opis usługi",
          nl: "2. Beschrijving van de dienst",
          no: "2. Beskrivelse av tjenesten",
        },
        p: [
          {
            de: "{{brand}} stellt digitale Tools für Restaurants bereit. Der Service kann eine digitale Speisekarte, QR-Code-Zugriff, Restaurantprofilseiten, Administrationswerkzeuge, Mehrsprachigkeit, Aktionsangebote und optionale Reservierungsfunktionen umfassen. Derzeit umfasst der Service keine Zahlungseinrichtung für Restaurantgäste.",
            en: "{{brand}} provides digital tools for restaurants. The Service may include a digital menu, QR code access, restaurant profile pages, administration tools, multilingual features, promotional offers and optional reservation features. At this stage, the Service does not include payment setup for restaurant guests.",
            uk: "{{brand}} надає цифрові інструменти для ресторанів. Сервіс може включати цифрове меню, доступ через QR-код, сторінки профілю ресторану, адмін-панель, багатомовність, акційні пропозиції та додаткові функції бронювання. На цьому етапі сервіс не включає налаштування оплат для гостей ресторану.",
            fr: "{{brand}} fournit des outils numériques pour les restaurants. Le service peut inclure un menu numérique, un accès par QR code, des pages de profil restaurant, des outils d’administration, des fonctions multilingues, des offres promotionnelles et des options de réservation. À ce stade, le service n’inclut pas la configuration de paiements pour les clients du restaurant.",
            pl: "{{brand}} udostępnia narzędzia cyfrowe dla restauracji. Usługa może obejmować menu cyfrowe, dostęp przez kod QR, strony profilu restauracji, narzędzia administracyjne, funkcje wielojęzyczne, oferty promocyjne i opcjonalne rezerwacje. Na tym etapie usługa nie obejmuje konfiguracji płatności dla gości restauracji.",
            nl: "{{brand}} biedt digitale tools voor restaurants. De dienst kan bestaan uit een digitaal menu, QR-codetoegang, restaurantprofielpagina’s, beheertools, meertalige functies, promotionele aanbiedingen en optionele reserveringsfuncties. Op dit moment omvat de dienst geen betalingsinstellingen voor restaurantgasten.",
            no: "{{brand}} tilbyr digitale verktøy for restauranter. Tjenesten kan omfatte digital meny, QR-kodetilgang, restaurantsider, administrasjonsverktøy, flerspråklige funksjoner, kampanjetilbud og valgfrie reservasjonsfunksjoner. På dette stadiet omfatter tjenesten ikke betalingsoppsett for restaurantgjester.",
          },
        ],
      },
      {
        h: {
          de: "3. Restaurantinhalte und Verantwortung des Kunden",
          en: "3. Restaurant content and customer responsibility",
          uk: "3. Контент ресторану та відповідальність клієнта",
          fr: "3. Contenu du restaurant et responsabilité du client",
          pl: "3. Treści restauracji i odpowiedzialność klienta",
          nl: "3. Restaurantcontent en verantwoordelijkheid van de klant",
          no: "3. Restaurantinnhold og kundens ansvar",
        },
        p: [
          {
            de: "Der Kunde ist allein verantwortlich für die Inhalte, die er im Service erstellt, hochlädt oder veröffentlicht. Dazu gehören Speisen, Getränke, Preise, Beschreibungen, Bilder, Logos, Öffnungszeiten, Kontaktdaten, Allergene, Zusatzstoffe und sonstige lebensmittelbezogene Informationen.",
            en: "The customer is solely responsible for the content created, uploaded or published through the Service. This includes dishes, drinks, prices, descriptions, images, logos, opening hours, contact details, allergens, additives and other food-related information.",
            uk: "Клієнт самостійно відповідає за контент, який створює, завантажує або публікує через сервіс. Це включає страви, напої, ціни, описи, зображення, логотипи, години роботи, контакти, алергени, добавки та іншу інформацію, пов’язану з харчовими продуктами.",
            fr: "Le client est seul responsable du contenu créé, téléversé ou publié via le service. Cela inclut les plats, boissons, prix, descriptions, images, logos, horaires, coordonnées, allergènes, additifs et autres informations alimentaires.",
            pl: "Klient ponosi wyłączną odpowiedzialność za treści tworzone, przesyłane lub publikowane za pośrednictwem usługi. Obejmuje to dania, napoje, ceny, opisy, zdjęcia, logotypy, godziny otwarcia, dane kontaktowe, alergeny, dodatki i inne informacje dotyczące żywności.",
            nl: "De klant is als enige verantwoordelijk voor content die via de dienst wordt gemaakt, geüpload of gepubliceerd. Dit omvat gerechten, dranken, prijzen, beschrijvingen, afbeeldingen, logo’s, openingstijden, contactgegevens, allergenen, additieven en andere voedselgerelateerde informatie.",
            no: "Kunden er alene ansvarlig for innhold som opprettes, lastes opp eller publiseres via tjenesten. Dette omfatter retter, drikke, priser, beskrivelser, bilder, logoer, åpningstider, kontaktopplysninger, allergener, tilsetningsstoffer og annen matrelatert informasjon.",
          },
          {
            de: "{{brand}} verkauft keine Speisen oder Getränke, betreibt kein Restaurant und übernimmt keine Verantwortung für die Richtigkeit oder Rechtmäßigkeit der Restaurantinhalte.",
            en: "{{brand}} does not sell food or drinks, does not operate a restaurant and does not take responsibility for the accuracy or legality of restaurant content.",
            uk: "{{brand}} не продає їжу чи напої, не керує рестораном і не відповідає за точність або законність контенту ресторану.",
            fr: "{{brand}} ne vend pas de plats ou boissons, n’exploite pas de restaurant et n’assume pas la responsabilité de l’exactitude ou de la légalité du contenu du restaurant.",
            pl: "{{brand}} nie sprzedaje jedzenia ani napojów, nie prowadzi restauracji i nie ponosi odpowiedzialności za dokładność ani zgodność z prawem treści restauracji.",
            nl: "{{brand}} verkoopt geen eten of drinken, exploiteert geen restaurant en is niet verantwoordelijk voor de juistheid of rechtmatigheid van restaurantcontent.",
            no: "{{brand}} selger ikke mat eller drikke, driver ikke restaurant og er ikke ansvarlig for riktigheten eller lovligheten av restaurantinnhold.",
          },
        ],
      },
      {
        h: {
          de: "4. Zahlungen",
          en: "4. Payments",
          uk: "4. Платежі",
          fr: "4. Paiements",
          pl: "4. Płatności",
          nl: "4. Betalingen",
          no: "4. Betalinger",
        },
        p: [
          {
            de: "Derzeit verarbeitet {{brand}} keine Zahlungen von Restaurantgästen für Speisen oder Getränke. Wenn kostenpflichtige SaaS-Abonnements für Restaurants aktiviert werden, zahlt der Restaurantkunde für die Nutzung der Software.",
            en: "At this stage, {{brand}} does not process restaurant guest payments for food or drinks. If paid SaaS subscriptions for restaurants are activated, the restaurant customer pays for the use of the software.",
            uk: "На цьому етапі {{brand}} не обробляє платежі гостей ресторану за їжу чи напої. Якщо будуть активовані платні SaaS-підписки для ресторанів, ресторан-клієнт платить за користування програмним забезпеченням.",
            fr: "À ce stade, {{brand}} ne traite pas les paiements des clients des restaurants pour les plats ou boissons. Si des abonnements SaaS payants pour restaurants sont activés, le restaurant client paie l’utilisation du logiciel.",
            pl: "Na tym etapie {{brand}} nie przetwarza płatności gości restauracji za jedzenie lub napoje. Jeśli zostaną aktywowane płatne subskrypcje SaaS dla restauracji, klient restauracyjny płaci za korzystanie z oprogramowania.",
            nl: "Op dit moment verwerkt {{brand}} geen betalingen van restaurantgasten voor eten of drinken. Als betaalde SaaS-abonnementen voor restaurants worden geactiveerd, betaalt de restaurantklant voor het gebruik van de software.",
            no: "På dette stadiet behandler {{brand}} ikke betalinger fra restaurantgjester for mat eller drikke. Hvis betalte SaaS-abonnementer for restauranter aktiveres, betaler restaurantkunden for bruk av programvaren.",
          },
        ],
      },
      {
        h: {
          de: "5. Verfügbarkeit und Änderungen",
          en: "5. Availability and changes",
          uk: "5. Доступність і зміни",
          fr: "5. Disponibilité et modifications",
          pl: "5. Dostępność i zmiany",
          nl: "5. Beschikbaarheid en wijzigingen",
          no: "5. Tilgjengelighet og endringer",
        },
        p: [
          {
            de: "Wir bemühen uns, den Service stabil und sicher bereitzustellen. Eine ununterbrochene Verfügbarkeit wird jedoch nicht garantiert. Wartung, technische Störungen, Updates oder externe Dienstleister können die Verfügbarkeit beeinflussen.",
            en: "We try to provide the Service in a stable and secure way. Uninterrupted availability is not guaranteed. Maintenance, technical issues, updates or third-party providers may affect availability.",
            uk: "Ми намагаємося надавати сервіс стабільно й безпечно. Безперервна доступність не гарантується. Обслуговування, технічні проблеми, оновлення або сторонні постачальники можуть впливати на доступність.",
            fr: "Nous nous efforçons de fournir le service de manière stable et sécurisée. La disponibilité ininterrompue n’est pas garantie. La maintenance, les problèmes techniques, les mises à jour ou des prestataires tiers peuvent affecter la disponibilité.",
            pl: "Staramy się świadczyć usługę stabilnie i bezpiecznie. Nie gwarantujemy nieprzerwanej dostępności. Konserwacja, problemy techniczne, aktualizacje lub dostawcy zewnętrzni mogą wpływać na dostępność.",
            nl: "Wij proberen de dienst stabiel en veilig aan te bieden. Ononderbroken beschikbaarheid wordt niet gegarandeerd. Onderhoud, technische problemen, updates of externe leveranciers kunnen de beschikbaarheid beïnvloeden.",
            no: "Vi forsøker å levere tjenesten stabilt og sikkert. Uavbrutt tilgjengelighet garanteres ikke. Vedlikehold, tekniske problemer, oppdateringer eller tredjepartsleverandører kan påvirke tilgjengeligheten.",
          },
        ],
      },
      {
        h: {
          de: "6. Datenschutz",
          en: "6. Data protection",
          uk: "6. Захист даних",
          fr: "6. Protection des données",
          pl: "6. Ochrona danych",
          nl: "6. Gegevensbescherming",
          no: "6. Personvern",
        },
        p: [
          {
            de: "Personenbezogene Daten werden gemäß der Datenschutzerklärung verarbeitet. Wenn ein Restaurant personenbezogene Daten seiner Gäste über den Service verarbeitet, bleibt das Restaurant grundsätzlich für diese Gästedaten verantwortlich.",
            en: "Personal data is processed according to the Privacy Policy. If a restaurant processes personal data of its guests through the Service, the restaurant generally remains responsible for that guest data.",
            uk: "Персональні дані обробляються відповідно до Політики конфіденційності. Якщо ресторан обробляє персональні дані своїх гостей через сервіс, ресторан зазвичай залишається відповідальним за ці дані гостей.",
            fr: "Les données personnelles sont traitées conformément à la Politique de confidentialité. Si un restaurant traite les données personnelles de ses clients via le service, le restaurant reste généralement responsable de ces données clients.",
            pl: "Dane osobowe są przetwarzane zgodnie z Polityką prywatności. Jeśli restauracja przetwarza dane osobowe swoich gości za pośrednictwem usługi, restauracja zasadniczo pozostaje odpowiedzialna za te dane.",
            nl: "Persoonsgegevens worden verwerkt volgens het Privacybeleid. Als een restaurant persoonsgegevens van gasten via de dienst verwerkt, blijft het restaurant doorgaans verantwoordelijk voor die gastgegevens.",
            no: "Personopplysninger behandles i henhold til personvernerklæringen. Hvis en restaurant behandler personopplysninger om sine gjester gjennom tjenesten, forblir restauranten som hovedregel ansvarlig for disse gjestedataene.",
          },
        ],
      },
      {
        h: {
          de: "7. Haftungsbeschränkung",
          en: "7. Limitation of liability",
          uk: "7. Обмеження відповідальності",
          fr: "7. Limitation de responsabilité",
          pl: "7. Ograniczenie odpowiedzialności",
          nl: "7. Beperking van aansprakelijkheid",
          no: "7. Ansvarsbegrensning",
        },
        p: [
          {
            de: "Soweit gesetzlich zulässig, haftet {{brand}} nicht für indirekte Schäden, entgangenen Gewinn, Betriebsunterbrechungen, Datenverlust oder Ansprüche, die aus Restaurantinhalten, falschen Preisen, Allergenen, Speiseninformationen oder Entscheidungen des Restaurantkunden entstehen.",
            en: "To the extent permitted by law, {{brand}} is not liable for indirect damages, lost profits, business interruption, data loss or claims arising from restaurant content, incorrect prices, allergens, food information or decisions made by the restaurant customer.",
            uk: "Наскільки це дозволено законом, {{brand}} не несе відповідальності за непрямі збитки, втрачений прибуток, переривання роботи бізнесу, втрату даних або претензії, що виникають через контент ресторану, неправильні ціни, алергени, інформацію про їжу чи рішення ресторану-клієнта.",
            fr: "Dans la mesure permise par la loi, {{brand}} n’est pas responsable des dommages indirects, pertes de profits, interruptions d’activité, pertes de données ou réclamations liées au contenu du restaurant, à des prix incorrects, aux allergènes, aux informations alimentaires ou aux décisions du restaurant client.",
            pl: "W zakresie dozwolonym przez prawo {{brand}} nie ponosi odpowiedzialności za szkody pośrednie, utracone korzyści, przerwy w działalności, utratę danych ani roszczenia wynikające z treści restauracji, błędnych cen, alergenów, informacji o żywności lub decyzji klienta restauracyjnego.",
            nl: "Voor zover wettelijk toegestaan is {{brand}} niet aansprakelijk voor indirecte schade, winstderving, bedrijfsonderbreking, gegevensverlies of claims die voortvloeien uit restaurantcontent, onjuiste prijzen, allergenen, voedselinformatie of beslissingen van de restaurantklant.",
            no: "I den grad loven tillater det, er {{brand}} ikke ansvarlig for indirekte tap, tapt fortjeneste, driftsavbrudd, datatap eller krav som oppstår fra restaurantinnhold, feil priser, allergener, matinformasjon eller restaurantkundens beslutninger.",
          },
        ],
      },
      {
        h: {
          de: "8. Anwendbares Recht",
          en: "8. Applicable law",
          uk: "8. Застосовне право",
          fr: "8. Droit applicable",
          pl: "8. Prawo właściwe",
          nl: "8. Toepasselijk recht",
          no: "8. Gjeldende rett",
        },
        p: [
          {
            de: "Diese Bedingungen unterliegen {{governingLaw}}, soweit zwingende gesetzliche Vorschriften nichts anderes vorsehen.",
            en: "These Terms are governed by {{governingLaw}}, unless mandatory legal rules provide otherwise.",
            uk: "Ці Умови регулюються правом: {{governingLaw}}, якщо обов’язкові норми законодавства не передбачають іншого.",
            fr: "Les présentes Conditions sont régies par {{governingLaw}}, sauf disposition légale impérative contraire.",
            pl: "Niniejszy Regulamin podlega prawu: {{governingLaw}}, chyba że bezwzględnie obowiązujące przepisy stanowią inaczej.",
            nl: "Deze Voorwaarden worden beheerst door {{governingLaw}}, tenzij dwingende wettelijke regels anders bepalen.",
            no: "Disse vilkårene reguleres av {{governingLaw}}, med mindre ufravikelige lovregler bestemmer noe annet.",
          },
        ],
      },
      {
        h: {
          de: "9. Kontakt",
          en: "9. Contact",
          uk: "9. Контакти",
          fr: "9. Contact",
          pl: "9. Kontakt",
          nl: "9. Contact",
          no: "9. Kontakt",
        },
        p: [
          {
            de: "Fragen zum Service können an {{email}} gesendet werden.",
            en: "Questions about the Service can be sent to {{email}}.",
            uk: "Питання щодо сервісу можна надсилати на {{email}}.",
            fr: "Les questions concernant le service peuvent être envoyées à {{email}}.",
            pl: "Pytania dotyczące usługi można wysyłać na {{email}}.",
            nl: "Vragen over de dienst kunnen worden gestuurd naar {{email}}.",
            no: "Spørsmål om tjenesten kan sendes til {{email}}.",
          },
        ],
      },
    ],
  },

  privacy: {
    title: {
      de: "Datenschutzerklärung",
      en: "Privacy Policy",
      uk: "Політика конфіденційності",
      fr: "Politique de confidentialité",
      pl: "Polityka prywatności",
      nl: "Privacybeleid",
      no: "Personvernerklæring",
    },
    intro: {
      de: "Diese Datenschutzerklärung erklärt, wie personenbezogene Daten bei der Nutzung von {{domain}} und des {{brand}}-Services verarbeitet werden.",
      en: "This Privacy Policy explains how personal data is processed when using {{domain}} and the {{brand}} service.",
      uk: "Ця Політика конфіденційності пояснює, як обробляються персональні дані під час використання {{domain}} та сервісу {{brand}}.",
      fr: "Cette Politique de confidentialité explique comment les données personnelles sont traitées lors de l’utilisation de {{domain}} et du service {{brand}}.",
      pl: "Niniejsza Polityka prywatności wyjaśnia, jak dane osobowe są przetwarzane podczas korzystania z {{domain}} i usługi {{brand}}.",
      nl: "Dit Privacybeleid legt uit hoe persoonsgegevens worden verwerkt bij het gebruik van {{domain}} en de {{brand}}-dienst.",
      no: "Denne personvernerklæringen forklarer hvordan personopplysninger behandles ved bruk av {{domain}} og {{brand}}-tjenesten.",
    },
    sections: [
      {
        h: {
          de: "1. Verantwortlicher",
          en: "1. Controller",
          uk: "1. Контролер даних",
          fr: "1. Responsable du traitement",
          pl: "1. Administrator danych",
          nl: "1. Verwerkingsverantwoordelijke",
          no: "1. Behandlingsansvarlig",
        },
        p: [
          {
            de: "Der Anbieter ist {{legalName}}, {{businessAddress}}, {{country}}. Datenschutzanfragen können an {{email}} gesendet werden.",
            en: "The provider is {{legalName}}, {{businessAddress}}, {{country}}. Privacy requests can be sent to {{email}}.",
            uk: "Постачальник: {{legalName}}, {{businessAddress}}, {{country}}. Запити щодо персональних даних можна надсилати на {{email}}.",
            fr: "Le fournisseur est {{legalName}}, {{businessAddress}}, {{country}}. Les demandes relatives à la confidentialité peuvent être envoyées à {{email}}.",
            pl: "Dostawcą jest {{legalName}}, {{businessAddress}}, {{country}}. Zapytania dotyczące prywatności można wysyłać na {{email}}.",
            nl: "De aanbieder is {{legalName}}, {{businessAddress}}, {{country}}. Privacyverzoeken kunnen worden gestuurd naar {{email}}.",
            no: "Leverandøren er {{legalName}}, {{businessAddress}}, {{country}}. Personvernforespørsler kan sendes til {{email}}.",
          },
        ],
      },
      {
        h: {
          de: "2. Rollen bei Restaurant- und Gästedaten",
          en: "2. Roles for restaurant and guest data",
          uk: "2. Ролі щодо даних ресторану та гостей",
          fr: "2. Rôles pour les données du restaurant et des clients",
          pl: "2. Role dotyczące danych restauracji i gości",
          nl: "2. Rollen voor restaurant- en gastgegevens",
          no: "2. Roller for restaurant- og gjestedata",
        },
        p: [
          {
            de: "Für Website-, Kontakt-, Konto-, Support- und Abrechnungsdaten verarbeitet {{brand}} Daten in eigener Verantwortung. Für personenbezogene Daten, die ein Restaurant über seine Gäste in den Service eingibt oder verwaltet, ist das Restaurant grundsätzlich Verantwortlicher und {{brand}} handelt als Dienstleister/Auftragsverarbeiter, soweit anwendbar.",
            en: "For website, contact, account, support and billing data, {{brand}} processes data as its own controller. For personal data that a restaurant enters or manages about its guests through the Service, the restaurant is generally the controller and {{brand}} acts as service provider/processor where applicable.",
            uk: "Для даних сайту, контактів, акаунтів, підтримки та білінгу {{brand}} обробляє дані як самостійний контролер. Для персональних даних гостей, які ресторан вносить або керує через сервіс, ресторан зазвичай є контролером, а {{brand}} діє як постачальник/процесор, де це застосовно.",
            fr: "Pour les données du site, de contact, de compte, de support et de facturation, {{brand}} traite les données en tant que responsable du traitement. Pour les données personnelles des clients qu’un restaurant saisit ou gère via le service, le restaurant est généralement le responsable du traitement et {{brand}} agit comme prestataire/sous-traitant lorsque cela s’applique.",
            pl: "W odniesieniu do danych strony, kontaktowych, konta, wsparcia i rozliczeń {{brand}} przetwarza dane jako administrator. W przypadku danych osobowych gości, które restauracja wprowadza lub zarządza przez usługę, restauracja zasadniczo jest administratorem, a {{brand}} działa jako usługodawca/podmiot przetwarzający, jeśli ma to zastosowanie.",
            nl: "Voor website-, contact-, account-, support- en factuurgegevens verwerkt {{brand}} gegevens als eigen verwerkingsverantwoordelijke. Voor persoonsgegevens van gasten die een restaurant via de dienst invoert of beheert, is het restaurant doorgaans de verwerkingsverantwoordelijke en treedt {{brand}} op als dienstverlener/verwerker waar van toepassing.",
            no: "For nettsted-, kontakt-, konto-, support- og faktureringsdata behandler {{brand}} data som egen behandlingsansvarlig. For personopplysninger om gjester som en restaurant legger inn eller administrerer gjennom tjenesten, er restauranten som hovedregel behandlingsansvarlig, og {{brand}} opptrer som tjenesteleverandør/databehandler der det er relevant.",
          },
        ],
      },
      {
        h: {
          de: "3. Daten, die verarbeitet werden können",
          en: "3. Data we may process",
          uk: "3. Дані, які можуть оброблятися",
          fr: "3. Données que nous pouvons traiter",
          pl: "3. Dane, które możemy przetwarzać",
          nl: "3. Gegevens die wij kunnen verwerken",
          no: "3. Data vi kan behandle",
        },
        list: [
          {
            de: "Kontakt- und Supportdaten: Name, E-Mail, Telefonnummer, Nachrichtentext.",
            en: "Contact and support data: name, email, phone number and message content.",
            uk: "Контактні дані та дані підтримки: ім’я, email, номер телефону та зміст повідомлення.",
            fr: "Données de contact et de support : nom, e-mail, numéro de téléphone et contenu du message.",
            pl: "Dane kontaktowe i wsparcia: imię i nazwisko, e-mail, numer telefonu i treść wiadomości.",
            nl: "Contact- en supportgegevens: naam, e-mail, telefoonnummer en berichtinhoud.",
            no: "Kontakt- og supportdata: navn, e-post, telefonnummer og meldingsinnhold.",
          },
          {
            de: "Kontodaten: Login, Passwort-Hash, Spracheinstellungen, Plan, Restaurantprofil.",
            en: "Account data: login, password hash, language settings, plan and restaurant profile.",
            uk: "Дані акаунта: логін, хеш пароля, мовні налаштування, тариф і профіль ресторану.",
            fr: "Données de compte : identifiant, hash du mot de passe, paramètres de langue, formule et profil du restaurant.",
            pl: "Dane konta: login, hash hasła, ustawienia językowe, plan i profil restauracji.",
            nl: "Accountgegevens: login, wachtwoordhash, taalinstellingen, abonnement en restaurantprofiel.",
            no: "Kontodata: innlogging, passordhash, språkinnstillinger, plan og restaurantprofil.",
          },
          {
            de: "Restaurantinhalte: Menüs, Kategorien, Produkte, Preise, Beschreibungen, Bilder, Logos, Öffnungszeiten.",
            en: "Restaurant content: menus, categories, items, prices, descriptions, images, logos and opening hours.",
            uk: "Контент ресторану: меню, категорії, позиції, ціни, описи, зображення, логотипи та години роботи.",
            fr: "Contenu du restaurant : menus, catégories, articles, prix, descriptions, images, logos et horaires.",
            pl: "Treści restauracji: menu, kategorie, pozycje, ceny, opisy, zdjęcia, logotypy i godziny otwarcia.",
            nl: "Restaurantcontent: menu’s, categorieën, items, prijzen, beschrijvingen, afbeeldingen, logo’s en openingstijden.",
            no: "Restaurantinnhold: menyer, kategorier, varer, priser, beskrivelser, bilder, logoer og åpningstider.",
          },
          {
            de: "Technische Daten: IP-Adresse, Browser, Gerät, Server-Logs, Zugriffszeiten und Sicherheitsereignisse.",
            en: "Technical data: IP address, browser, device, server logs, access times and security events.",
            uk: "Технічні дані: IP-адреса, браузер, пристрій, серверні логи, час доступу та події безпеки.",
            fr: "Données techniques : adresse IP, navigateur, appareil, journaux serveur, heures d’accès et événements de sécurité.",
            pl: "Dane techniczne: adres IP, przeglądarka, urządzenie, logi serwera, czasy dostępu i zdarzenia bezpieczeństwa.",
            nl: "Technische gegevens: IP-adres, browser, apparaat, serverlogs, toegangstijden en beveiligingsgebeurtenissen.",
            no: "Tekniske data: IP-adresse, nettleser, enhet, serverlogger, tilgangstidspunkter og sikkerhetshendelser.",
          },
        ],
      },
      {
        h: {
          de: "4. Zwecke und Rechtsgrundlagen",
          en: "4. Purposes and legal bases",
          uk: "4. Цілі та правові підстави",
          fr: "4. Finalités et bases légales",
          pl: "4. Cele i podstawy prawne",
          nl: "4. Doeleinden en rechtsgronden",
          no: "4. Formål og rettslige grunnlag",
        },
        p: [
          {
            de: "Daten werden verarbeitet, um den Service bereitzustellen, Konten zu verwalten, Restaurantseiten zu veröffentlichen, Support zu leisten, Sicherheit zu gewährleisten, Missbrauch zu verhindern, gesetzliche Pflichten zu erfüllen und den Service zu verbessern.",
            en: "Data is processed to provide the Service, manage accounts, publish restaurant pages, provide support, maintain security, prevent abuse, comply with legal obligations and improve the Service.",
            uk: "Дані обробляються для надання сервісу, керування акаунтами, публікації сторінок ресторанів, підтримки, безпеки, запобігання зловживанням, виконання юридичних обов’язків і покращення сервісу.",
            fr: "Les données sont traitées pour fournir le service, gérer les comptes, publier les pages de restaurants, assurer le support, maintenir la sécurité, prévenir les abus, respecter les obligations légales et améliorer le service.",
            pl: "Dane są przetwarzane w celu świadczenia usługi, zarządzania kontami, publikowania stron restauracji, zapewnienia wsparcia, bezpieczeństwa, zapobiegania nadużyciom, spełniania obowiązków prawnych i ulepszania usługi.",
            nl: "Gegevens worden verwerkt om de dienst te leveren, accounts te beheren, restaurantpagina’s te publiceren, support te bieden, veiligheid te handhaven, misbruik te voorkomen, wettelijke verplichtingen na te komen en de dienst te verbeteren.",
            no: "Data behandles for å levere tjenesten, administrere kontoer, publisere restaurantsider, gi support, opprettholde sikkerhet, forhindre misbruk, oppfylle juridiske forpliktelser og forbedre tjenesten.",
          },
          {
            de: "Je nach Situation stützen wir die Verarbeitung auf Vertragserfüllung, berechtigte Interessen, Einwilligung oder gesetzliche Verpflichtungen.",
            en: "Depending on the situation, processing is based on contract performance, legitimate interests, consent or legal obligations.",
            uk: "Залежно від ситуації обробка ґрунтується на виконанні договору, законному інтересі, згоді або юридичних обов’язках.",
            fr: "Selon la situation, le traitement repose sur l’exécution du contrat, les intérêts légitimes, le consentement ou les obligations légales.",
            pl: "W zależności od sytuacji przetwarzanie opiera się na wykonaniu umowy, uzasadnionych interesach, zgodzie lub obowiązkach prawnych.",
            nl: "Afhankelijk van de situatie is de verwerking gebaseerd op uitvoering van de overeenkomst, gerechtvaardigde belangen, toestemming of wettelijke verplichtingen.",
            no: "Avhengig av situasjonen bygger behandlingen på oppfyllelse av avtale, berettigede interesser, samtykke eller juridiske forpliktelser.",
          },
        ],
      },
      {
        h: {
          de: "5. Cookies und Analyse",
          en: "5. Cookies and analytics",
          uk: "5. Cookies та аналітика",
          fr: "5. Cookies et analyse",
          pl: "5. Pliki cookie i analityka",
          nl: "5. Cookies en analyse",
          no: "5. Informasjonskapsler og analyse",
        },
        p: [
          {
            de: "Die Website kann notwendige Cookies oder ähnliche Technologien verwenden. Analyse- oder Marketing-Tools werden, soweit erforderlich, nur mit Einwilligung eingesetzt. Details sollten in einer separaten Cookie-Information ergänzt werden, wenn solche Tools aktiv sind.",
            en: "The website may use necessary cookies or similar technologies. Analytics or marketing tools are used with consent where required. Details should be added in a separate cookie notice if such tools are active.",
            uk: "Сайт може використовувати необхідні cookies або подібні технології. Аналітичні чи маркетингові інструменти використовуються за згодою там, де це потрібно. Якщо такі інструменти активні, деталі варто додати в окреме повідомлення про cookies.",
            fr: "Le site peut utiliser des cookies nécessaires ou des technologies similaires. Les outils d’analyse ou de marketing sont utilisés avec consentement lorsque cela est requis. Les détails doivent être ajoutés dans une notice cookies distincte si ces outils sont actifs.",
            pl: "Strona może używać niezbędnych plików cookie lub podobnych technologii. Narzędzia analityczne lub marketingowe są używane za zgodą, jeśli jest ona wymagana. Szczegóły należy dodać w osobnej informacji o cookies, jeśli takie narzędzia są aktywne.",
            nl: "De website kan noodzakelijke cookies of vergelijkbare technologieën gebruiken. Analyse- of marketingtools worden gebruikt met toestemming waar dat vereist is. Details moeten worden toegevoegd in een afzonderlijke cookiemelding als zulke tools actief zijn.",
            no: "Nettstedet kan bruke nødvendige informasjonskapsler eller lignende teknologier. Analyse- eller markedsføringsverktøy brukes med samtykke der dette kreves. Detaljer bør legges til i en egen cookie-melding hvis slike verktøy er aktive.",
          },
        ],
      },
      {
        h: {
          de: "6. Zahlungsdaten",
          en: "6. Payment data",
          uk: "6. Платіжні дані",
          fr: "6. Données de paiement",
          pl: "6. Dane płatnicze",
          nl: "6. Betaalgegevens",
          no: "6. Betalingsdata",
        },
        p: [
          {
            de: "Wenn kostenpflichtige Abonnements aktiviert werden, werden Zahlungen voraussichtlich über {{paymentProvider}} oder einen anderen externen Zahlungsdienstleister verarbeitet. Für regelmäßige Zahlungen können Zahlungskennungen, Transaktionsnummern, Token, Abonnementstatus und Daten zur nächsten Abbuchung gespeichert werden. Vollständige Kartendaten sollen nicht auf den Servern von {{brand}} gespeichert werden.",
            en: "If paid subscriptions are activated, payments are expected to be processed through {{paymentProvider}} or another external payment provider. For recurring payments, payment identifiers, transaction numbers, tokens, subscription status and next billing dates may be stored. Full card details should not be stored on {{brand}} servers.",
            uk: "Якщо будуть активовані платні підписки, платежі, ймовірно, оброблятимуться через {{paymentProvider}} або іншого зовнішнього платіжного провайдера. Для регулярних платежів можуть зберігатися ідентифікатори платежів, номери транзакцій, токени, статус підписки та дати наступного списання. Повні дані карток не мають зберігатися на серверах {{brand}}.",
            fr: "Si des abonnements payants sont activés, les paiements devraient être traités via {{paymentProvider}} ou un autre prestataire de paiement externe. Pour les paiements récurrents, des identifiants de paiement, numéros de transaction, tokens, statuts d’abonnement et dates de prochaine facturation peuvent être conservés. Les données complètes de carte ne doivent pas être stockées sur les serveurs de {{brand}}.",
            pl: "Jeśli płatne subskrypcje zostaną aktywowane, płatności prawdopodobnie będą przetwarzane przez {{paymentProvider}} lub innego zewnętrznego dostawcę płatności. Dla płatności cyklicznych mogą być przechowywane identyfikatory płatności, numery transakcji, tokeny, status subskrypcji i daty kolejnego obciążenia. Pełne dane kart nie powinny być przechowywane na serwerach {{brand}}.",
            nl: "Als betaalde abonnementen worden geactiveerd, worden betalingen naar verwachting verwerkt via {{paymentProvider}} of een andere externe betalingsprovider. Voor terugkerende betalingen kunnen betalings-ID’s, transactienummers, tokens, abonnementsstatus en volgende factuurdata worden opgeslagen. Volledige kaartgegevens mogen niet op de servers van {{brand}} worden opgeslagen.",
            no: "Hvis betalte abonnementer aktiveres, forventes betalinger å bli behandlet via {{paymentProvider}} eller en annen ekstern betalingsleverandør. For gjentakende betalinger kan betalings-ID-er, transaksjonsnumre, tokens, abonnementsstatus og neste trekkdato lagres. Fullstendige kortopplysninger bør ikke lagres på {{brand}} sine servere.",
          },
        ],
      },
      {
        h: {
          de: "7. Dienstleister und internationale Übermittlungen",
          en: "7. Service providers and international transfers",
          uk: "7. Постачальники та міжнародна передача даних",
          fr: "7. Prestataires et transferts internationaux",
          pl: "7. Dostawcy usług i transfery międzynarodowe",
          nl: "7. Dienstverleners en internationale doorgiften",
          no: "7. Tjenesteleverandører og internasjonale overføringer",
        },
        p: [
          {
            de: "Wir können technische Dienstleister einsetzen, z. B. Hosting, Datenbankbetrieb, E-Mail, Analyse, Kommunikation oder Zahlungsabwicklung. Wenn Daten außerhalb des EWR verarbeitet werden, müssen geeignete Schutzmaßnahmen geprüft und dokumentiert werden.",
            en: "We may use technical service providers, for example for hosting, database operation, email, analytics, communication or payment processing. If data is processed outside the EEA, appropriate safeguards must be checked and documented.",
            uk: "Ми можемо використовувати технічних постачальників, наприклад для хостингу, баз даних, email, аналітики, комунікацій або платежів. Якщо дані обробляються за межами ЄЕЗ, потрібно перевірити й задокументувати відповідні гарантії захисту.",
            fr: "Nous pouvons utiliser des prestataires techniques, par exemple pour l’hébergement, les bases de données, l’e-mail, l’analyse, la communication ou les paiements. Si des données sont traitées hors EEE, des garanties appropriées doivent être vérifiées et documentées.",
            pl: "Możemy korzystać z technicznych dostawców usług, np. hostingu, baz danych, poczty e-mail, analityki, komunikacji lub płatności. Jeśli dane są przetwarzane poza EOG, należy sprawdzić i udokumentować odpowiednie zabezpieczenia.",
            nl: "Wij kunnen technische dienstverleners gebruiken, bijvoorbeeld voor hosting, databasebeheer, e-mail, analytics, communicatie of betalingsverwerking. Als gegevens buiten de EER worden verwerkt, moeten passende waarborgen worden gecontroleerd en gedocumenteerd.",
            no: "Vi kan bruke tekniske tjenesteleverandører, for eksempel til hosting, databasedrift, e-post, analyse, kommunikasjon eller betalingsbehandling. Hvis data behandles utenfor EØS, må egnede garantier kontrolleres og dokumenteres.",
          },
        ],
      },
      {
        h: {
          de: "8. Speicherdauer",
          en: "8. Retention",
          uk: "8. Строк зберігання",
          fr: "8. Durée de conservation",
          pl: "8. Okres przechowywania",
          nl: "8. Bewaartermijn",
          no: "8. Lagringstid",
        },
        p: [
          {
            de: "Personenbezogene Daten werden nur so lange gespeichert, wie dies für die beschriebenen Zwecke, den Betrieb des Kontos, gesetzliche Pflichten, Nachweise oder berechtigte Interessen erforderlich ist.",
            en: "Personal data is stored only for as long as necessary for the described purposes, account operation, legal obligations, evidence or legitimate interests.",
            uk: "Персональні дані зберігаються лише стільки, скільки потрібно для описаних цілей, роботи акаунта, юридичних обов’язків, доказів або законних інтересів.",
            fr: "Les données personnelles sont conservées uniquement aussi longtemps que nécessaire pour les finalités décrites, le fonctionnement du compte, les obligations légales, les preuves ou les intérêts légitimes.",
            pl: "Dane osobowe są przechowywane tylko tak długo, jak jest to konieczne dla opisanych celów, działania konta, obowiązków prawnych, dowodów lub uzasadnionych interesów.",
            nl: "Persoonsgegevens worden alleen bewaard zolang dat nodig is voor de beschreven doeleinden, accountbeheer, wettelijke verplichtingen, bewijs of gerechtvaardigde belangen.",
            no: "Personopplysninger lagres bare så lenge det er nødvendig for de beskrevne formålene, kontodrift, juridiske forpliktelser, dokumentasjon eller berettigede interesser.",
          },
        ],
      },
      {
        h: {
          de: "9. Rechte der betroffenen Personen",
          en: "9. Data subject rights",
          uk: "9. Права суб’єктів даних",
          fr: "9. Droits des personnes concernées",
          pl: "9. Prawa osób, których dane dotyczą",
          nl: "9. Rechten van betrokkenen",
          no: "9. Registrertes rettigheter",
        },
        p: [
          {
            de: "Je nach anwendbarem Recht können Personen Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit oder Widerspruch verlangen und eine Einwilligung widerrufen. Anfragen können an {{email}} gesendet werden.",
            en: "Depending on applicable law, individuals may request access, correction, deletion, restriction, portability or objection and may withdraw consent. Requests can be sent to {{email}}.",
            uk: "Залежно від застосовного права особи можуть вимагати доступ, виправлення, видалення, обмеження, перенесення даних або заперечення, а також відкликати згоду. Запити можна надсилати на {{email}}.",
            fr: "Selon le droit applicable, les personnes peuvent demander l’accès, la rectification, l’effacement, la limitation, la portabilité ou l’opposition et peuvent retirer leur consentement. Les demandes peuvent être envoyées à {{email}}.",
            pl: "W zależności od właściwego prawa osoby mogą żądać dostępu, sprostowania, usunięcia, ograniczenia, przenoszenia danych lub sprzeciwu oraz mogą wycofać zgodę. Wnioski można wysyłać na {{email}}.",
            nl: "Afhankelijk van het toepasselijke recht kunnen personen verzoeken om inzage, correctie, verwijdering, beperking, overdraagbaarheid of bezwaar en kunnen zij toestemming intrekken. Verzoeken kunnen worden gestuurd naar {{email}}.",
            no: "Avhengig av gjeldende rett kan personer be om innsyn, retting, sletting, begrensning, dataportabilitet eller protestere, og de kan trekke tilbake samtykke. Forespørsler kan sendes til {{email}}.",
          },
        ],
      },
    ],
  },

  refund: {
    title: {
      de: "Kündigung & Erstattung",
      en: "Cancellation & Refunds",
      uk: "Скасування і повернення",
      fr: "Annulation et remboursements",
      pl: "Anulowanie i zwroty",
      nl: "Annulering en terugbetalingen",
      no: "Avbestilling og refusjon",
    },
    intro: {
      de: "Diese Richtlinie beschreibt, wie Kündigungen und Erstattungen für {{brand}} behandelt werden.",
      en: "This policy explains how cancellations and refunds are handled for {{brand}}.",
      uk: "Ця політика пояснює, як обробляються скасування та повернення коштів у {{brand}}.",
      fr: "Cette politique explique comment les annulations et remboursements sont traités pour {{brand}}.",
      pl: "Niniejsza polityka wyjaśnia, jak obsługiwane są anulowania i zwroty w {{brand}}.",
      nl: "Dit beleid legt uit hoe annuleringen en terugbetalingen voor {{brand}} worden afgehandeld.",
      no: "Denne policyen forklarer hvordan avbestillinger og refusjoner håndteres for {{brand}}.",
    },
    sections: [
      {
        h: {
          de: "1. Kostenlose Pilotversion",
          en: "1. Free pilot",
          uk: "1. Безкоштовний пілот",
          fr: "1. Version pilote gratuite",
          pl: "1. Bezpłatny pilotaż",
          nl: "1. Gratis pilot",
          no: "1. Gratis pilot",
        },
        p: [
          {
            de: "Wenn der Service kostenlos bereitgestellt wird, werden keine Zahlungen eingezogen und es besteht kein Erstattungsprozess.",
            en: "If the Service is provided free of charge, no payments are collected and no refund process applies.",
            uk: "Якщо сервіс надається безкоштовно, платежі не стягуються і процедура повернення не застосовується.",
            fr: "Si le service est fourni gratuitement, aucun paiement n’est encaissé et aucune procédure de remboursement ne s’applique.",
            pl: "Jeśli usługa jest świadczona bezpłatnie, płatności nie są pobierane i procedura zwrotu nie ma zastosowania.",
            nl: "Als de dienst gratis wordt geleverd, worden er geen betalingen geïnd en is er geen terugbetalingsproces van toepassing.",
            no: "Hvis tjenesten leveres gratis, innkreves ingen betalinger og ingen refusjonsprosess gjelder.",
          },
        ],
      },
      {
        h: {
          de: "2. Kostenpflichtige Abonnements",
          en: "2. Paid subscriptions",
          uk: "2. Платні підписки",
          fr: "2. Abonnements payants",
          pl: "2. Płatne subskrypcje",
          nl: "2. Betaalde abonnementen",
          no: "2. Betalte abonnementer",
        },
        p: [
          {
            de: "Wenn kostenpflichtige Abonnements aktiviert werden, erhält der Restaurantkunde vor Beginn regelmäßiger Zahlungen eine kostenlose Testphase von {{trialDays}} Tagen. Der Kunde kann während der Testphase kündigen. Nach der Testphase verlängert sich das Abonnement monatlich, bis es gemäß den im Konto oder im Angebot angegebenen Bedingungen gekündigt wird.",
            en: "If paid subscriptions are activated, the restaurant customer receives a free {{trialDays}}-day trial before recurring payments begin. The customer may cancel during the trial. After the trial, the subscription renews monthly until cancelled according to the conditions shown in the account or offer.",
            uk: "Якщо будуть активовані платні підписки, ресторан-клієнт отримує безкоштовний тестовий період {{trialDays}} днів до початку регулярних платежів. Клієнт може скасувати підписку під час тестового періоду. Після тестового періоду підписка поновлюється щомісяця, доки її не буде скасовано відповідно до умов, показаних в акаунті або пропозиції.",
            fr: "Si des abonnements payants sont activés, le restaurant client bénéficie d’un essai gratuit de {{trialDays}} jours avant le début des paiements récurrents. Le client peut annuler pendant l’essai. Après l’essai, l’abonnement se renouvelle mensuellement jusqu’à son annulation selon les conditions indiquées dans le compte ou l’offre.",
            pl: "Jeśli płatne subskrypcje zostaną aktywowane, klient restauracyjny otrzymuje bezpłatny {{trialDays}}-dniowy okres próbny przed rozpoczęciem płatności cyklicznych. Klient może zrezygnować w trakcie okresu próbnego. Po okresie próbnym subskrypcja odnawia się co miesiąc do momentu anulowania zgodnie z warunkami wskazanymi na koncie lub w ofercie.",
            nl: "Als betaalde abonnementen worden geactiveerd, krijgt de restaurantklant een gratis proefperiode van {{trialDays}} dagen voordat terugkerende betalingen beginnen. De klant kan tijdens de proefperiode annuleren. Na de proefperiode wordt het abonnement maandelijks verlengd totdat het wordt geannuleerd volgens de voorwaarden in het account of aanbod.",
            no: "Hvis betalte abonnementer aktiveres, får restaurantkunden en gratis prøveperiode på {{trialDays}} dager før gjentakende betalinger starter. Kunden kan kansellere i prøveperioden. Etter prøveperioden fornyes abonnementet månedlig til det kanselleres i henhold til vilkårene som vises i kontoen eller tilbudet.",
          },
        ],
      },
      {
        h: {
          de: "3. Erstattungen",
          en: "3. Refunds",
          uk: "3. Повернення коштів",
          fr: "3. Remboursements",
          pl: "3. Zwroty",
          nl: "3. Terugbetalingen",
          no: "3. Refusjoner",
        },
        p: [
          {
            de: "Erstattungen für bereits genutzte Abonnementzeiträume werden grundsätzlich nicht gewährt, es sei denn, dies ist gesetzlich vorgeschrieben oder es liegt ein nachweisbarer Doppelbetrag, technischer Fehler oder eine anders vereinbarte Kulanzentscheidung vor.",
            en: "Refunds for already used subscription periods are generally not provided unless required by law, caused by a proven duplicate charge or technical error, or agreed as a goodwill exception.",
            uk: "Повернення за вже використані періоди підписки зазвичай не надається, якщо цього не вимагає закон, якщо не було доведеного подвійного списання чи технічної помилки, або якщо інше не погоджено як виняток.",
            fr: "Les remboursements pour les périodes d’abonnement déjà utilisées ne sont généralement pas accordés, sauf obligation légale, double débit prouvé, erreur technique ou geste commercial convenu.",
            pl: "Zwroty za już wykorzystane okresy subskrypcji zasadniczo nie są przyznawane, chyba że wymaga tego prawo, wystąpiła udowodniona podwójna opłata lub błąd techniczny albo uzgodniono wyjątek w ramach dobrej woli.",
            nl: "Terugbetalingen voor reeds gebruikte abonnementsperioden worden doorgaans niet verstrekt, tenzij wettelijk vereist, veroorzaakt door een bewezen dubbele afschrijving of technische fout, of overeengekomen als coulance-uitzondering.",
            no: "Refusjoner for allerede brukte abonnementsperioder gis normalt ikke, med mindre loven krever det, det foreligger en dokumentert dobbeltbelastning eller teknisk feil, eller det er avtalt som et goodwill-unntak.",
          },
        ],
      },
      {
        h: {
          de: "4. Verbraucherrechte",
          en: "4. Consumer rights",
          uk: "4. Права споживачів",
          fr: "4. Droits des consommateurs",
          pl: "4. Prawa konsumentów",
          nl: "4. Consumentenrechten",
          no: "4. Forbrukerrettigheter",
        },
        p: [
          {
            de: "{{brand}} richtet sich an Geschäftskunden. Wenn der Service in Zukunft Verbrauchern angeboten wird, müssen gesonderte Verbraucherinformationen, Widerrufsbelehrungen und gesetzlich erforderliche Funktionen ergänzt werden.",
            en: "{{brand}} is intended for business customers. If the Service is offered to consumers in the future, separate consumer information, withdrawal instructions and legally required features must be added.",
            uk: "{{brand}} призначений для бізнес-клієнтів. Якщо в майбутньому сервіс буде пропонуватися споживачам, потрібно додати окрему інформацію для споживачів, інструкції щодо права відмови та функції, передбачені законом.",
            fr: "{{brand}} est destiné aux clients professionnels. Si le service est proposé à des consommateurs à l’avenir, des informations consommateurs distinctes, des instructions de rétractation et les fonctions légalement requises devront être ajoutées.",
            pl: "{{brand}} jest przeznaczony dla klientów biznesowych. Jeśli w przyszłości usługa będzie oferowana konsumentom, należy dodać odrębne informacje konsumenckie, pouczenia o odstąpieniu i wymagane prawem funkcje.",
            nl: "{{brand}} is bedoeld voor zakelijke klanten. Als de dienst in de toekomst aan consumenten wordt aangeboden, moeten afzonderlijke consumenteninformatie, herroepingsinstructies en wettelijk vereiste functies worden toegevoegd.",
            no: "{{brand}} er beregnet på bedriftskunder. Hvis tjenesten i fremtiden tilbys forbrukere, må separat forbrukerinformasjon, angrerettsinformasjon og lovpålagte funksjoner legges til.",
          },
        ],
      },
      {
        h: {
          de: "5. Kontakt",
          en: "5. Contact",
          uk: "5. Контакти",
          fr: "5. Contact",
          pl: "5. Kontakt",
          nl: "5. Contact",
          no: "5. Kontakt",
        },
        p: [
          {
            de: "Fragen zu Kündigungen oder Erstattungen können an {{email}} gesendet werden.",
            en: "Questions about cancellations or refunds can be sent to {{email}}.",
            uk: "Питання щодо скасувань або повернень можна надсилати на {{email}}.",
            fr: "Les questions concernant les annulations ou remboursements peuvent être envoyées à {{email}}.",
            pl: "Pytania dotyczące anulowania lub zwrotów można wysyłać na {{email}}.",
            nl: "Vragen over annuleringen of terugbetalingen kunnen worden gestuurd naar {{email}}.",
            no: "Spørsmål om avbestillinger eller refusjoner kan sendes til {{email}}.",
          },
        ],
      },
    ],
  },

  impressum: {
    title: {
      de: "Impressum",
      en: "Legal Notice",
      uk: "Правова інформація",
      fr: "Mentions légales",
      pl: "Informacje prawne",
      nl: "Juridische kennisgeving",
      no: "Juridisk informasjon",
    },
    intro: {
      de: "Informationen zum Anbieter dieser Website und des {{brand}}-Services.",
      en: "Information about the provider of this website and the {{brand}} service.",
      uk: "Інформація про постачальника цього сайту та сервісу {{brand}}.",
      fr: "Informations sur le fournisseur de ce site et du service {{brand}}.",
      pl: "Informacje o dostawcy tej strony internetowej i usługi {{brand}}.",
      nl: "Informatie over de aanbieder van deze website en de {{brand}}-dienst.",
      no: "Informasjon om leverandøren av dette nettstedet og {{brand}}-tjenesten.",
    },
    sections: [
      {
        h: {
          de: "Anbieter",
          en: "Provider",
          uk: "Постачальник",
          fr: "Fournisseur",
          pl: "Dostawca",
          nl: "Aanbieder",
          no: "Leverandør",
        },
        p: [
          {
            de: "{{legalName}}\n{{businessAddress}}\n{{country}}\nWebsite: {{siteUrl}}\nRegistrierung/Steuernummer: {{registrationNumber}}\nUSt-IdNr.: {{vatId}}",
            en: "{{legalName}}\n{{businessAddress}}\n{{country}}\nWebsite: {{siteUrl}}\nRegistration/tax number: {{registrationNumber}}\nVAT ID: {{vatId}}",
            uk: "{{legalName}}\n{{businessAddress}}\n{{country}}\nСайт: {{siteUrl}}\nРеєстраційний/податковий номер: {{registrationNumber}}\nVAT ID / ПДВ: {{vatId}}",
            fr: "{{legalName}}\n{{businessAddress}}\n{{country}}\nSite : {{siteUrl}}\nNuméro d’enregistrement/fiscal : {{registrationNumber}}\nTVA : {{vatId}}",
            pl: "{{legalName}}\n{{businessAddress}}\n{{country}}\nStrona: {{siteUrl}}\nNumer rejestracyjny/podatkowy: {{registrationNumber}}\nNIP/VAT UE: {{vatId}}",
            nl: "{{legalName}}\n{{businessAddress}}\n{{country}}\nWebsite: {{siteUrl}}\nRegistratie-/belastingnummer: {{registrationNumber}}\nBtw-id: {{vatId}}",
            no: "{{legalName}}\n{{businessAddress}}\n{{country}}\nNettsted: {{siteUrl}}\nRegistrerings-/skattenummer: {{registrationNumber}}\nMVA-ID: {{vatId}}",
          },
        ],
      },
      {
        h: {
          de: "Kontakt",
          en: "Contact",
          uk: "Контакти",
          fr: "Contact",
          pl: "Kontakt",
          nl: "Contact",
          no: "Kontakt",
        },
        p: [
          {
            de: "E-Mail: {{email}}\nTelefon: {{phone}}\nSupportzeiten: {{supportHours}}",
            en: "Email: {{email}}\nPhone: {{phone}}\nSupport hours: {{supportHours}}",
            uk: "Email: {{email}}\nТелефон: {{phone}}\nГодини підтримки: {{supportHours}}",
            fr: "E-mail : {{email}}\nTéléphone : {{phone}}\nHoraires du support : {{supportHours}}",
            pl: "E-mail: {{email}}\nTelefon: {{phone}}\nGodziny wsparcia: {{supportHours}}",
            nl: "E-mail: {{email}}\nTelefoon: {{phone}}\nSupporturen: {{supportHours}}",
            no: "E-post: {{email}}\nTelefon: {{phone}}\nSupporttider: {{supportHours}}",
          },
        ],
      },
      {
        h: {
          de: "Status des Services",
          en: "Service status",
          uk: "Статус сервісу",
          fr: "Statut du service",
          pl: "Status usługi",
          nl: "Status van de dienst",
          no: "Tjenestestatus",
        },
        p: [
          {
            de: "{{brand}} ist ein B2B-SaaS-Service für Restaurants. Der Service kann als Pilotversion, kostenlose Testversion oder kostenpflichtiges Abonnement angeboten werden. {{brand}} stellt Software für digitale Speisekarten, mehrsprachige Menüinhalte, Aktionsangebote, Restaurant-Subdomains und Reservierungen bereit. {{brand}} verkauft keine Speisen oder Getränke, betreibt kein Restaurant und verarbeitet keine Zahlungen von Restaurantgästen.",
            en: "{{brand}} is a B2B SaaS service for restaurants. The Service may be offered as a pilot, free trial or paid subscription. {{brand}} provides software for digital menus, multilingual menu content, promotional offers, restaurant subdomains and reservations. {{brand}} does not sell food or drinks, does not operate a restaurant and does not process payments from restaurant guests.",
            uk: "{{brand}} — це B2B SaaS-сервіс для ресторанів. Сервіс може надаватися як пілот, безкоштовний тестовий період або платна підписка. {{brand}} надає програмне забезпечення для цифрового меню, багатомовного контенту меню, акційних пропозицій, ресторанних субдоменів і бронювання. {{brand}} не продає їжу чи напої, не керує рестораном і не обробляє платежі гостей ресторану.",
            fr: "{{brand}} est un service SaaS B2B pour les restaurants. Le service peut être proposé comme pilote, essai ou abonnement payant. {{brand}} ne vend pas de plats ou boissons et n’exploite pas de restaurant.",
            pl: "{{brand}} to usługa SaaS B2B dla restauracji. Usługa może być oferowana jako pilotaż, wersja testowa lub płatna subskrypcja. {{brand}} nie sprzedaje jedzenia ani napojów i nie prowadzi restauracji.",
            nl: "{{brand}} is een B2B SaaS-dienst voor restaurants. De dienst kan worden aangeboden als pilot, proefversie of betaald abonnement. {{brand}} verkoopt geen eten of drinken en exploiteert geen restaurant.",
            no: "{{brand}} er en B2B SaaS-tjeneste for restauranter. Tjenesten kan tilbys som pilot, prøveversjon eller betalt abonnement. {{brand}} selger ikke mat eller drikke og driver ikke restaurant.",
          },
        ],
      },
      {
        h: {
          de: "Verantwortung für Inhalte",
          en: "Responsibility for content",
          uk: "Відповідальність за контент",
          fr: "Responsabilité du contenu",
          pl: "Odpowiedzialność za treści",
          nl: "Verantwoordelijkheid voor content",
          no: "Ansvar for innhold",
        },
        p: [
          {
            de: "Restaurantbetreiber sind verantwortlich für Speisen, Preise, Bilder, Beschreibungen, Allergene, Öffnungszeiten, Kontaktdaten und sonstige Inhalte, die sie über den Service bereitstellen.",
            en: "Restaurant operators are responsible for dishes, prices, images, descriptions, allergens, opening hours, contact details and other content they provide through the Service.",
            uk: "Оператори ресторанів відповідають за страви, ціни, зображення, описи, алергени, години роботи, контактні дані та інший контент, який вони надають через сервіс.",
            fr: "Les exploitants de restaurants sont responsables des plats, prix, images, descriptions, allergènes, horaires, coordonnées et autres contenus qu’ils fournissent via le service.",
            pl: "Operatorzy restauracji odpowiadają za dania, ceny, zdjęcia, opisy, alergeny, godziny otwarcia, dane kontaktowe i inne treści udostępniane przez usługę.",
            nl: "Restaurantondernemers zijn verantwoordelijk voor gerechten, prijzen, afbeeldingen, beschrijvingen, allergenen, openingstijden, contactgegevens en andere content die zij via de dienst aanbieden.",
            no: "Restaurantoperatører er ansvarlige for retter, priser, bilder, beskrivelser, allergener, åpningstider, kontaktopplysninger og annet innhold de tilbyr gjennom tjenesten.",
          },
        ],
      },
      {
        h: {
          de: "Hinweis zur Online-Streitbeilegung",
          en: "Online dispute resolution note",
          uk: "Примітка щодо онлайн-вирішення спорів",
          fr: "Note sur le règlement en ligne des litiges",
          pl: "Informacja o internetowym rozstrzyganiu sporów",
          nl: "Opmerking over online geschillenbeslechting",
          no: "Merknad om nettbasert tvisteløsning",
        },
        p: [
          {
            de: "Der Service richtet sich an Geschäftskunden. Wenn Verbraucherdienste in Zukunft angeboten werden, müssen die dann geltenden Informationspflichten separat geprüft werden.",
            en: "The Service is intended for business customers. If consumer services are offered in the future, the applicable information duties must be checked separately.",
            uk: "Сервіс призначений для бізнес-клієнтів. Якщо в майбутньому послуги будуть пропонуватися споживачам, відповідні інформаційні обов’язки потрібно буде перевірити окремо.",
            fr: "Le service est destiné aux clients professionnels. Si des services consommateurs sont proposés à l’avenir, les obligations d’information applicables devront être vérifiées séparément.",
            pl: "Usługa jest przeznaczona dla klientów biznesowych. Jeśli w przyszłości usługi będą oferowane konsumentom, właściwe obowiązki informacyjne należy sprawdzić osobno.",
            nl: "De dienst is bedoeld voor zakelijke klanten. Als in de toekomst consumentendiensten worden aangeboden, moeten de toepasselijke informatieplichten afzonderlijk worden gecontroleerd.",
            no: "Tjenesten er beregnet på bedriftskunder. Hvis forbrukertjenester tilbys i fremtiden, må gjeldende informasjonsplikter kontrolleres separat.",
          },
        ],
      },
      {
        h: {
          de: "Letzte Aktualisierung",
          en: "Last updated",
          uk: "Останнє оновлення",
          fr: "Dernière mise à jour",
          pl: "Ostatnia aktualizacja",
          nl: "Laatst bijgewerkt",
          no: "Sist oppdatert",
        },
        p: [
          {
            de: "{{lastUpdated}}",
            en: "{{lastUpdated}}",
            uk: "{{lastUpdated}}",
            fr: "{{lastUpdated}}",
            pl: "{{lastUpdated}}",
            nl: "{{lastUpdated}}",
            no: "{{lastUpdated}}",
          },
        ],
      },
    ],
  },
};
